import React from 'react';
import { Controller } from 'react-hook-form';
import { Form, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';

const SellingOptionsForm = ({ control, errors }) => {
  return (
    <>
      <Row className="mb-3 g-3">
        <Form.Group>
          {[
            { key: 'LEASE_LAND', text: 'Lease land' },
            { key: 'LEASE_CO2', text: 'Lease carbon offset credit' }
          ].map(option => (
            <Controller
              key={option.key}
              name="sellingOption"
              control={control}
              rules={{ required: 'You must select an option.' }}
              render={({ field }) => (
                <Form.Check
                  type="radio"
                  label={option.text}
                  value={option.key}
                  checked={field.value === option.key}
                  onChange={e => field.onChange(e.target.value)}
                />
              )}
            />
          ))}
          {errors.sellingOption && (
            <p className="text-danger">{errors.sellingOption.message}</p>
          )}
        </Form.Group>
      </Row>
    </>
  );
};

SellingOptionsForm.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};

export default SellingOptionsForm;
